// src/constants/enums.ts

export enum VoteOption {
	RED = 1,
	WHITE = 2,
}

export enum VoteReasonKey {
	SWEET_TOMATO = 'sweet_tomato',
    VERSATILE = 'versatile',
    NO_FAIL = 'no_fail',
    WESTERN_STYLE = 'western_style',
    HOKKAIDO_MILK = 'hokkaido_milk',
    RICH_FLAVOR = 'rich_flavor',
    FAMILY_FAVORITE = 'family_favorite',
}

export const VoteReasonLabel: Record<VoteReasonKey, string> = {
    [VoteReasonKey.SWEET_TOMATO]: '使用完熟蕃茄，口味酸甜適中',
    [VoteReasonKey.VERSATILE]: '百搭食材，可以變化出各種美味料理',
    [VoteReasonKey.NO_FAIL]: '不需調味，料理新手也不會失敗的神級料理塊',
    [VoteReasonKey.WESTERN_STYLE]: '煮義大利麵、焗烤超好吃，簡單就能煮出日本洋食的風味',
    [VoteReasonKey.HOKKAIDO_MILK]: '奶香濃郁，100%北海道鮮奶製成',
    [VoteReasonKey.RICH_FLAVOR]: '料理完整呈現北海道鮮奶的濃郁香醇口感',
    [VoteReasonKey.FAMILY_FAVORITE]: '大小朋友都很喜歡',
};
    
export enum EndPoints {
    GET_VOTE_DATA = '/vote/count',
    VOTE = '/vote',

    GET_UPLOAD_PRESIGNED_URL = '/invoice/file/upload',
    FILE_UPLOADED = '/invoice/file/uploaded',
    REGISTER_INVOICE = '/invoice'
}


export function getEnumKeyByValue(enumType: any, enumValue: any): string | undefined {
  return Object.keys(enumType).find(key => enumType[key] === enumValue);
}
